export const enum statusType {
  Error = 'error',
  Success = 'success',
  Warning = 'warning',
  Neutral = 'neutral',
  Info = 'info'
}

export const StatusList:{id:string,name: string}[] = [
  {
    "id": "ACTIVE",
    "name":"Active"
  },
  {
    "id": "INACTIVE",
    "name":"Inactive"
  },
  {
    "id": "CONFIRM",
    "name":"Confirm"
  },
  {
    "id": "PENDING",
    "name":"Pending"
  }
];
